export const getProductGroupsSuccess = (groups) => {
    return {
        type: "GET_PRODUCT_GROUPS_SUCCESS",
        payload: groups
    }
};
